import styled from 'styled-components';

const Amount = styled.div`
    font-weight: bold;
    color: ${(props) => props.theme.warning};
`;

export { Amount };
